import PostingSupplyCase from '@/models/PostingSupplyForProduction/PostingSupplyCase';

export default class PostingSupplyCaseFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.postingSupplyForProductionId  = '';
		this.postingSupplyForProductionPickingSupplyForProduction = '';
		this.postingSupplyDetailForProductionId  = '';
		this.postingSupplyDetailForProductionPickingSupplyForProductionDetail = '';
		this.pickingSupplyDetailForProductionId  = '';
		this.pickingSupplyDetailForProductionMaterialPart = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qty = '';
		this.areaId  = '';
		this.areaCode = '';
		this.rackId  = '';
		this.rackCode = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			postingSupplyForProductionId : '0',
			postingSupplyForProductionPickingSupplyForProduction : '0',
			postingSupplyDetailForProductionId : '0',
			postingSupplyDetailForProductionPickingSupplyForProductionDetail : '0',
			pickingSupplyDetailForProductionId : '0',
			pickingSupplyDetailForProductionMaterialPart : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			qty : '0',
			areaId : '0',
			areaCode : '0',
			rackId : '0',
			rackCode : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}